import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

const base = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 1, seriesName: 'Uptime' });

export const IOTS_UPTIME_LINE_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Uptime',
            data: base.series[0].data.map((point, index) => ({
                label: point.label,
                value: Math.min(100, Math.max(88, 97 - (index % 9 === 0 ? 8 : 0) - (index % 11 === 0 ? 4 : 0)))
            }))
        }
    ]
};
